import { useEffect } from 'react';

function useOnKeyDown(targetKey: string, handler: () => void) {
  const downHandler = ({ key }: KeyboardEvent) => {
    if (key === targetKey) {
      handler();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
    };
  }, []);
}

export default useOnKeyDown;
